import { render, staticRenderFns } from "./pagenoutfound.vue?vue&type=template&id=5f48b1dc&scoped=true&"
import script from "./pagenoutfound.vue?vue&type=script&lang=js&"
export * from "./pagenoutfound.vue?vue&type=script&lang=js&"
import style0 from "./pagenoutfound.vue?vue&type=style&index=0&id=5f48b1dc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f48b1dc",
  null
  
)

export default component.exports